import { render, staticRenderFns } from "./branchallcountList.vue?vue&type=template&id=5bc29164&scoped=true"
import script from "./branchallcountList.vue?vue&type=script&lang=js"
export * from "./branchallcountList.vue?vue&type=script&lang=js"
import style0 from "./branchallcountList.vue?vue&type=style&index=0&id=5bc29164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc29164",
  null
  
)

export default component.exports